<script>
    import { http } from '@/system/http';
    import Switchery from 'Components/global/form/Switchery.vue';
    import CustomStatusModal from 'Modules/AppointmentStatus/resources/js/CustomStatusModal.vue';
    import orderBy from 'lodash/orderBy';
    import forEach from 'lodash/forEach';
    import includes from 'lodash/includes';
    import size from 'lodash/size';
    import Sortable, {Swap} from 'sortablejs';

    const systemStatuses = [
        'not_started',
        'arrived',
        'started',
        'finished',
        'absent',
        'cancelled'
    ];

    export default {
        systemStatuses: systemStatuses,

        props: {
            initialSettings: {
                required: true,
            }
        },

        data() {
            return {
                loading: false,
                settings: this.initialSettings,
                systemStatuses: systemStatuses,
                sortedStatuses: [],
                lastStatusInOrder: {},
                lastStatusByID: {}
            }
        },

        mounted() {
            this.sortStatuses();
            this.lastStatusById();
            this.sortableStatuses();

            this.$event_bus.$on('add', () => {
                $("#custom-status-modal").modal('show');
            });

            this.$event_bus.$on('delete', (payload) => {
                this.deleteCustomStatus(payload);
            });

            this.$event_bus.$on('submit', (payload) => {
                this.settings.statuses[payload.id] = payload;
                this.saveSettings();
            });
        },

        methods: {
            saveSettings() {
                this.loading = true;

                http.post('/app/settings/apps/booking-status/settings', this.settings)
                    .then(({ data }) => {
                        this.loading = false;
                        toastr.success(data.success);
                        this.settings = data.settings;
                        this.sortStatuses();
                        this.lastStatusById();
                        this.errors.clear();
                        $("#custom-status-modal").modal('hide');
                        this.$event_bus.$emit('success');
                    }).catch(({ error, errorBag }) => {
                        this.loading = false;
                        this.errors.clear();
                        if (errorBag) {
                            swal({
                                title: trans('global.error_title'),
                                text: errorBag.items[0].msg,
                                closeOnConfirm: true,
                            });
                        }
                    });
            },

            addCustomStatus() {
                this.$event_bus.$emit('add');
            },

            editCustomStatus(status) {
                this.$event_bus.$emit('edit', status);
            },

            deleteCustomStatus(status) {
                delete this.settings.statuses[status.id];
                this.saveSettings();
            },

            sortStatuses() {
                this.sortedStatuses = [];
                let statuses = orderBy({...this.settings.statuses}, 'order');

                forEach(statuses, (status) => {
                    if (this.has_custom_status) {
                        if (!includes(this.systemStatuses, status.name)) {
                            this.sortedStatuses.push(status)
                        }
                    } else {
                        this.sortedStatuses = statuses;
                        return false;
                    }
                });

                this.lastStatusInOrder = this.sortedStatuses[this.sortedStatuses.length - 1];
            },

            lastStatusById() {
                this.lastStatusByID = {};
                let statuses = orderBy({...this.settings.statuses}, 'id');

                this.lastStatusByID = statuses[statuses.length -1];
            },

            sortableStatuses() {
                let vm = this;

                this.$nextTick(()=>{
                    Sortable.mount(new Swap());

                    Sortable.create(document.getElementById('custom_statuses'), {
                        handle: '.zmdi-swap-vertical',
                        swapClass: 'swap-ghost',
                        animation: 150,
                        swap: true,
                        onUpdate: function(event) {
                            let statusDragged = {...vm.sortedStatuses[event.oldIndex]};
                            let statusSwapped = {...vm.sortedStatuses[event.newIndex]};

                            vm.settings.statuses[statusDragged.id].order = statusSwapped.order;
                            vm.settings.statuses[statusSwapped.id].order = statusDragged.order;

                            vm.saveSettings();
                        }
                    });
                });
            }
        },

        computed: {
            has_custom_status() {
                return size(this.settings.statuses) > 6;
            },
        },

        beforeUnmount() {
            this.$event_bus.$off('add');
            this.$event_bus.$off('delete');
            this.$event_bus.$off('submit');
        },

        components: {
            Switchery,
            CustomStatusModal
        }
    }
</script>

<template>
    <div  id="bookingStatusSettings">
        <form action="" method="post" @submit.prevent="saveSettings">

        <div class="row m-b-20">
            <div class="col-xs-12">
                <button type="submit" class="btn btn-custom" :disabled="loading"><i class="zmdi zmdi-check m-r-5"></i> <span>{{ trans('settings.save_settings') }}</span></button>
                <button type="submit" class="btn btn-custom btn-trans m-l-10" @click.prevent="addCustomStatus()"><i class="fa-regular fa-plus m-r-5"></i> <span>{{ trans('settings.custom_status_create') }}</span></button>
            </div>
        </div>

        <div class="row">

            <div class="col-xs-12 col-sm-6">
                <div class="panel panel-border panel-custom ">

                    <div class="panel-heading">
                        <h3 class="header-title">{{ trans('modules.AppointmentStatus.booking_status_available') }}</h3>
                        <p class="text-muted m-b-0"><small>{{ trans('modules.AppointmentStatus.booking_status_description') }}</small></p>
                    </div>

                    <div class="panel-body">
                        <template v-for="status in settings.statuses">
                            <div v-if="systemStatuses.includes(status.name)" :key="`system-status-${status.id}`">
                                <a href="#" v-if="has_custom_status && sortedStatuses.length > 1"><i class="zmdi zmdi-swap-vertical"></i></a>
                                <i class="status_icon_class" :class="status.icon_class"></i>
                                <switchery
                                    :text="trans('modules.AppointmentStatus.booking_statuses.'+status.name)"
                                    :name="'enable_status'"
                                    v-model="status.active"
                                ></switchery>
                            </div>
                        </template>

                        <div id="custom_statuses">
                            <template v-for="status in sortedStatuses" >
                                <div v-if="!systemStatuses.includes(status.name)" :key="`custom-status-${status.id}`">
                                    <span>
                                        <a href="#"  v-if="has_custom_status && sortedStatuses.length > 1"><i class="zmdi zmdi-swap-vertical"></i></a>
                                        <i class="status_icon_class" :class="status.icon_class"></i>
                                        <switchery
                                            :text="status.name"
                                            :name="'enable_status'"
                                            v-model="status.active"
                                            class="custom_status">
                                        </switchery>

                                        <a class="custom_status_edit" href="" @click.prevent="editCustomStatus(status)" v-tooltip="trans('global.edit')"><i class="zmdi zmdi-edit m-l-10"></i></a>

                                    </span>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <custom-status-modal v-if="lastStatusInOrder.order" :lastOrder="lastStatusInOrder.order" :last-id="lastStatusByID.id"></custom-status-modal>

    </form>
    </div>
</template>
